import React from 'react';
import PropTypes from 'prop-types';
import Price from 'common/price/Price';

const PriceDisplay = ({currencyType, price, isDefault, pricePerDay}) => {
    const priceLabel = pricePerDay ? 'Per Day' : 'Total Price';

    return (
        <div className="PriceDisplay">
            {isDefault && <span className="PriceDisplay-pre-label">From </span>}
            <Price amount={price} currencyType={currencyType} />
            <span className="PriceDisplay-label">{priceLabel}</span>
        </div>
    );
};

PriceDisplay.propTypes = {
    currencyType: PropTypes.string,
    price: PropTypes.number.isRequired,
    isDefault: PropTypes.bool,
    pricePerDay: PropTypes.bool,
};

PriceDisplay.defaultProps = {
    pricePerDay: true,
};

export default PriceDisplay;
